import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Text = styled.span`
  text-transform: none;
`;

export default function InvestmentHorizonInfo({ fund }) {
  return <Text>{_.get(fund, 'investmentHorizon')}</Text>;
}

InvestmentHorizonInfo.propTypes = {
  fund: PropTypes.shape({
    investmentHorizon: PropTypes.string,
  }).isRequired,
};
